<template>
  <v-layout>
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12>
      <v-card-title class="">
        <div class="">
          <span class="headline red--text mx-0">Team </span>
        </div>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 sm6 mr-2>
              <v-select
                v-model="projectTeamData.team"
                :rules="team"
                :items="indexData.teams"
                :item-text="textItem"
                item-value="id"
                multiple
                box
                @change="calculateDasherNumber"
                label="Select Team"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <p>
                Number Available Dasher:
                {{ projectTeamData.numberOfDasherAvailable }}
              </p>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <button class="button" flat @click="back">Back</button>
        <v-btn class="button" flat @click="submit">Save & next</v-btn>
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
// import router from "../../router";

export default {
  props:{
    dasher_category_id: Number,
  },
  data: () => ({
    apiUrl: "project-dasher-category",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    dialog: false,
    projectTeamData: {
      team: [],
      numberOfDasherAvailable: 0,
      noTeam: false,
      dasher_category: 1,
      project_id: null,
    },
    defaultItem: {
      team: [],
      numberOfDasherAvailable: 0,
      noTeam: false,
      dasher_category: 1,
      // project_id: null,
    },
    submitTeamData: {
      data: [],
    },
    valid: true,
    team: [(v) => v.length > 0 || "Teams is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    dasher_category_check: function () {
      // console.log(this.dasher_category);
      return true;
    },

    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {},

  created() {
    this.initialize();
    // this.editedData()
  },
  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.projectTeamData.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },
    select_category(value) {
      this.projectTeamData.dasher_category = value;
    },

    textItem: function (event) {
      return (
        event.team_name +
        " : " +
        event.team_code +
        "(" +
        event.numberOfDasher +
        ")"
      );
    },
    calculateDasherNumber: function () {
      var numberOfDasherAvailable = 0;
      if (this.projectTeamData.team.length) {
        this.projectTeamData.team.forEach((elements) => {
          this.indexData.teams.forEach((element) => {
            if (elements == element.id) {
              numberOfDasherAvailable =
                parseInt(numberOfDasherAvailable) +
                parseInt(element.numberOfDasher);
            }
          });
        });
        this.projectTeamData.numberOfDasherAvailable = numberOfDasherAvailable;
      } else {
        this.projectTeamData.numberOfDasherAvailable = 0;
      }
      // console.log(this.projectTeamData.numberOfDasherAvailable);
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    getProjectType() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_type_id) {
          return this.indexData.project_data.project_type_id;
        }
      }
      return false;
    },
    assignTeamToProject() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-dasher-category",
        project_id,
        "/assign-teams-to-Project",
      ]);
    },
    createProjectPage() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-info",
        project_id,
        "/create-project-edit",
      ]);
    },

    back() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "question-json",
        project_id,
        "/dynamic-question",
      ]);
    },

    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    submit() {
      this.projectTeamData.dasher_category=this.dasher_category_id;
      // console.log(this.projectTeamData);
      if (this.$refs.form.validate()) {
        if (
          this.projectTeamData.dasher_category == 2 &&
          this.projectTeamData.team.length == 0
        ) {
          alert("please select at lest a team");
        } else {
          this.submitTeamData.data = this.projectTeamData;
          this.$store.dispatch("storeOrUpdateTeamAssignment", [
            "assign-teams-to-project",
            this.projectTeamData,
          ]);
        }
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.no-upercase {
  text-transform: unset !important;
}
</style>
